import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Allocate } from '../listTeams/components/teamAllocate.dumb';
import { Team } from '../../../state/reduxRepositories/teams/team.interfaces';
import { dateTime } from '../../../time/datetime';

interface AddedPlayersProps {
  onAddPlayer: (id: string) => void;
  onRemovePlayer: (mode: 'players' | 'manager' | boolean, id: string) => void;
  team: Team;
}

export const AddedPlayers = ({
  onRemovePlayer,
  onAddPlayer,
  team,
}: AddedPlayersProps) => {
  const { t } = useTranslation();
  return (
    <Grid>
      {team.players.map((teamPlayer) => {
        return (
          <Grid item key={teamPlayer?.id} sx={{ my: 1 }}>
            <Allocate
              clearedToPlay={teamPlayer?.clearedToPlay}
              mode="players"
              type="list"
              isAllocated={
                team?.playerIds
                  ? team?.playerIds.includes(teamPlayer.id)
                  : false
              }
              onRemoveAllocate={onRemovePlayer}
              allocateById={teamPlayer?.id}
              onAllocate={onAddPlayer}
              name={`${teamPlayer?.firstName} ${teamPlayer?.lastName}`}
              bday={dateTime.format(
                teamPlayer?.dateOfBirth,
                t('common.datetime.FORMAT_SHORT_DATE'),
              )}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
